var informPopupData = {
	cookieName : 'akvw77js',
	campaignName : 'matching-challenge',
	campaignUrl : 'https://aclj.org/aclj/tax-deductible-donations-doubled-today',
	//campaignUrl : '/donate',
	dateCheck : isMatchingChallenge(),
	bgImageUrl : "https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/Matching_Popup_Doubled.png"
	//bgImageUrl : "https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/Matching_Popup_Deadline.png"
}
var profilePopupData = {
	cookieName : 'c2816gdr',
	campaignName : 'complete-profile',
	campaignUrl : 'https://aclj.org/profile',
	bgImageUrl : 'https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/Profile_popup_2.0.jpg'
}
var ads = [{
	cookieName : 'j5k67b2',
	campaignName : 'livsSignAd',
	campaignUrl : 'http://livesigning.com/jay',
	urlMapping : [
		{
			url:'https://www.amazon.com/Unholy-Alliance-Agenda-Jihadists-Conquering/dp/1501141023/ref=tmm_hrd_swatch_0',
			x:208,
			y:322,
			height:33,
			width:68},
		{
			url:'http://www.barnesandnoble.com/w/unholy-alliance-jay-sekulow/1124177390',
			x:284,
			y:322,
			height:33,
			width:68}
	],
	bgImageUrl : 'https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/LiveSign_Popup.jpg',
	dateCheck: function(){
		var currentDT = new Date();
		var minDT = new Date(Date.UTC(2016,8,22,20+5,0,0)); //NOTE: +5 on hours to convert to central time (kinda sorta)
		var maxDT = new Date(Date.UTC(2016,8,22,21+5,0,0));
		if(currentDT > minDT && currentDT < maxDT){
			return true;
		}
		return false;
	}(),
	expiresIn:1*24*60*60*1000 //NOTE: 1 day to live
},{
	cookieName : 'j5k67bg',
	campaignName : 'unholyBookAd',
	campaignUrl : 'https://www.amazon.com/Unholy-Alliance-Agenda-Jihadists-Conquering/dp/1501141023/ref=tmm_hrd_swatch_0',
	urlMapping : [
		{
			url:'https://www.amazon.com/Unholy-Alliance-Agenda-Jihadists-Conquering/dp/1501141023/ref=tmm_hrd_swatch_0',
			x:231,
			y:171,
			height:51,
			width:104},
		{
			url:'http://www.barnesandnoble.com/w/unholy-alliance-jay-sekulow/1124177390',
			x:231,
			y:237,
			height:51,
			width:104}
	],
	bgImageUrl : 'https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/Unholy_Popup2.jpg',
	dateCheck: function(){
		var currentDT = new Date();
		var minDT = new Date(2016,8,20);
		var maxDT = new Date(2016,8,25);
		if(currentDT > minDT && currentDT < maxDT){
			return true;
		}
		return false;
	}(),
	expiresIn:3*24*60*60*1000 //NOTE: 3 days to live
}
]
function createLinks(urlMapping){
	var imageHeight=377;
	var imageWidth=377;
	var htmlLinks = '';
	for(var i=0;i<urlMapping.length;i++){
		var width = (urlMapping[i].width/imageWidth)*100;
		var height = (urlMapping[i].height/imageHeight)*100;
		var top = (urlMapping[i].y/imageHeight)*100;
		var left = (urlMapping[i].x/imageWidth)*100;
		htmlLinks += '<a style="position:absolute;width:' + width + '%;height:' + height + '%;top:' + top + '%;left:' + left + '%" href="' + urlMapping[i].url + '" target="_blank">'
	}
	return htmlLinks;
}
var runPopupCampaign = function(){
	// if(mobileCheck()==true) return;
	for(var i=0;i<ads.length;i++){
		var currentAd = ads[i];
		if(cookies.getItem(currentAd.cookieName) !== currentAd.campaignName && currentAd.dateCheck){
			preloadBGImage = new Image();
			preloadBGImage.src = currentAd.bgImageUrl;
			preloadBGImage.onload=function(){
				$.fancybox.open({
					maxWidth	: 377,
					maxHeight	: 377,
					width		: '80%',
					height		: 'auto',
					fitToView	: false,
					autoSize	: false,
					closeClick	: false,
					openEffect	: 'fade',
					closeEffect	: 'fade',
					padding 	: 0,
					margin		: 0,
					scrolling	: 'no',
					content		: '<div style="position:relative;">' +
						'<a target="_blank" href="' + currentAd.campaignUrl + '">' +
						'<img class="img-responsive" src="' + currentAd.bgImageUrl + '" />' + 
						'</a>' +
						createLinks(currentAd.urlMapping) + 
						'</div>'
				});

				var d = new Date();
				d.setTime(d.getTime() + currentAd.expiresIn); 
				cookies.setItem(currentAd.cookieName, currentAd.campaignName, d.toUTCString(), '/', null, true, "Strict", false);

				//counting impressions
				dataLayer.push({'event': 'Info Campaign Displayed', 'info_campaign_name': config.campaignName})
			}
			return; //NOTE: stop processing ads.
		}
	}
	if(cookies.getItem(informPopupData.cookieName) !== informPopupData.campaignName && informPopupData.dateCheck){
		if (document.images) {
			if(isYearEnd())
				informPopupData.bgImageUrl ="https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/year-end-matching-challenge-2.jpg";
			if(isDeadline())
				informPopupData.bgImageUrl ="https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/Matching_Popup_Deadline.png";
			preloadBGImage = new Image();
			preloadBGImage.src = informPopupData.bgImageUrl;
			preloadBGImage.onload=function(){
				$.fancybox.open({
					maxWidth	: 377,
					maxHeight	: 377,
					width		: '80%',
					height		: 'auto',
					fitToView	: false,
					autoSize	: false,
					closeClick	: false,
					openEffect	: 'fade',
					closeEffect	: 'fade',
					padding 	: 0,
					margin		: 0,
					scrolling	: 'no',
					content		: '<div><style>#infoContainer{max-width: 377px;max-height: 377px;padding-right: 0;padding-left: 0;position: relative;display: block;text-align: center;text-decoration: none;}</style><a id="infoContainer" href="' + informPopupData.campaignUrl + '?utm_source=sitePopup&utm_campaign=' + informPopupData.campaignName + '"" onclick="dataLayer.push({\'event\':\'Info Campaign Click\',\'info_campaign_name\':\'' + informPopupData.campaignName + '\'});"><img class="img-responsive" src="' + informPopupData.bgImageUrl + '"></a></div>'					
				});
				//IE <= 8 doesn't support max-age, so i'm using a date string w/ expires 
				var d = new Date();
				var secondToLastDate = new Date(d.getFullYear(), d.getMonth() + 1,-1);
				var ninethToLastDate = new Date(d.getFullYear(), d.getMonth() + 1,-8);
				//checks if seven days before deadline popup change and expires cookie two days before end of month
				if(ninethToLastDate.getDate() <= d.getDate() && d.getDate() < secondToLastDate.getDate()){
					cookies.setItem(informPopupData.cookieName, informPopupData.campaignName, secondToLastDate.toUTCString(), '/', null, true, "Strict", false);
				} else {
					d.setTime(d.getTime() + 7*24*60*60*1000); //7 days to live
					cookies.setItem(informPopupData.cookieName, informPopupData.campaignName, d.toUTCString(), '/', null, true, "Strict", false);
				}
				//counting impressions
				dataLayer.push({'event': 'Info Campaign Displayed', 'info_campaign_name': informPopupData.campaignName})
			}
		}
	}else if(cookies.getItem(profilePopupData.cookieName) !== profilePopupData.campaignName){ //Profile fill ad if matching challenge is not active
		var member = fetchMemberInfo();
		if(typeof member !== 'undefined' && member !== null && typeof member.sessionKey !== 'undefined'){
			//check for complete address
			var status = sharedFunctions.addressCompleted(member);
			if(status !== 'complete'){  //empty or partial addresses only
				var bgImage = new Image();
				bgImage.src = profilePopupData.bgImageUrl;
				bgImage.onload = function(){
					$.fancybox.open({
						maxWidth	: 377,
						maxHeight	: 377,
						width		: '80%',
						height		: 'auto',
						fitToView	: false,
						autoSize	: false,
						closeClick	: false,
						openEffect	: 'fade',
						closeEffect	: 'fade',
						padding 	: 0,
						margin		: 0,
						scrolling	: 'no',
						content     : '<div><style>#infoContainer{max-width: 377px;max-height: 377px;padding-right: 0;padding-left: 0;position: relative;display: block;text-align: center;text-decoration: none;}</style><a id="infoContainer" href="' + profilePopupData.campaignUrl + '?utm_source=sitePopup&utm_campaign=' + profilePopupData.campaignName + '"><img class="img-responsive" src="' + profilePopupData.bgImageUrl + '"></a></div>'
					})
					var d = new Date();
					d.setTime(d.getTime() + 31*24*60*60*1000); //30 days to live
					cookies.setItem(profilePopupData.cookieName, profilePopupData.campaignName, d.toUTCString(), '/', null, true, "Strict", false);
				}
			}
		}
	}
}